import React, { useState } from 'react'
import CreateTeamModal from './CreateTeamModal';

const CreateTeamBtn = (props) => {
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const CreateTeamFn = () => {
        // console.log("CreateTeamFn")
        setModalOpen(true);
    }
    return (
        <>

            <button className='btn btn-primary' onClick={CreateTeamFn} >Create a Team</button>
            <CreateTeamModal
                assignTeam={props.assignTeam}
                isOpen={modalOpen}
                toggle={toggleModal}
                setTeamMembers={props.setTeamMembers}
                setInGroup={props.setInGroup}
                setTeamName={props.setTeamName}
            />
        </>
    )
}

export default CreateTeamBtn